import { Component, OnInit } from '@angular/core';
import * as Rx from 'rxjs';
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client';
import { GlobalNgWord } from 'src/lib/entity/live';

@Component({
  selector: 'ng-word',
  templateUrl: './ng-word.component.html',
  styleUrls: ['../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss', './ng-word.component.scss']
})
export class NgWordComponent implements OnInit {

  globalNgWords$: Rx.Observable<GlobalNgWord[] | "NOT_AUTHORIZED">;
  ngWordInput: string;

  constructor() { }

  ngOnInit(): void {
    this.reloadGlobalNgWordList();
  }

  addGlobalNgWord(word: string) {
    MagliveApiClient.addGlobalNgWord(word)
      .subscribe(() => setTimeout(() => this.reloadGlobalNgWordList(), 500));
  }

  deleteGlobalNgWord(globalNgWordId: string) {
    MagliveApiClient.deleteGlobalNgWord(globalNgWordId)
      .subscribe(() => setTimeout(() => this.reloadGlobalNgWordList(), 500))
  }

  private reloadGlobalNgWordList() {
    this.globalNgWords$ = MagliveApiClient.listGlobalNgWords();
  }
}
